import { Stack, Typography } from "@mui/material";
import { Position } from "@xyflow/react";

import type { RuleNodeProps, SortRuleNode } from "../types/nodes";
import AddHiddenHandle from "./AddHiddenHandle";
import BaseNode from "./BaseNode";

type SortNodeProps = RuleNodeProps<SortRuleNode>;

const SortNode = (props: SortNodeProps) => {
	const { data } = props;
	const conditions = data.conditions ?? [];

	return (
		<BaseNode {...props}>
			<Stack spacing={1.25}>
				{conditions.length ? (
					<Stack spacing={0.5}>
						{conditions.map((c, index) => {
							const fieldDisplay = c.sortByFieldName || c.sortByDatabaseTableFieldId || c.sortByScreenTableFieldId || "";
							return (
								<Typography
									variant="body2"
									color="text.primary"
									key={`${fieldDisplay}-${index}`}
								>
									{index + 1}. {fieldDisplay} ({c.sortOrder === "desc" ? "Z → A" : "A → Z"})
								</Typography>
							);
						})}
					</Stack>
				) : (
					<Typography variant="body2" color="text.disabled">
            No sorting fields configured
					</Typography>
				)}
			</Stack>
			<AddHiddenHandle
				type="target"
				position={Position.Top}
				id="in"
			/>
		</BaseNode>
	);
};

export default SortNode;
